import React, { Component, createRef } from 'react'
//import TableComp from '../../../../components/_utils/table'
import { RightsWrapper } from '../../../../components/_utils/utils'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import setting from '../../../../components/_utils/settings'
import { TableComp } from 'sz-react-utils'

import { Link } from "react-router-dom";
import _ from 'lodash'
import moment from 'moment'
import { Button, Card, Col, DatePicker, Drawer, Form, notification, Popconfirm, Row, Tooltip, Switch } from 'antd'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, MEDIA_URL } from '../../../../request'

import { connect } from 'react-redux'
import styles from './styles.less'
import { getUrlPushWrapper } from '../../../../routes'

import commonStyle from '../../../common.less'

import userRights from "../../../../components/_utils/userRights";
const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : null;
const currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const { RangePicker } = DatePicker


@Form.create()
class EditNameDrawer extends Component {
    state = {
        visible: true
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }



    componentDidMount = () => {
        let { record, type, form } = this.props;
        setTimeout(() => {
            form.setFieldsValue({ name: type === "city" && record ? record.cityName : record.stateName })
        }, 50)

    }

    handleSubmit = (e) => {
        let { form, type, record } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let response
            if (type == "city") {
                values._id = record._id;
                values.cityName = values.name;
                values.countryId = record.countryId;
                values.stateId = record.stateId;
                delete values.name;
                response = await Request.updateCity(values);
            } else if (type === "state") {
                values._id = record._id;
                values.stateName = values.name;
                values.countryId = record.countryId;
                delete values.name;
                response = await Request.updateState(values);
            }
            if (response.success) {
                notification.success({
                    message: response.msg
                })
            } else {
                notification.error({
                    message: response.msg
                })
            }
            this.onClose();
        })
    }

    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Name',
                    key: 'name',
                    required: true
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        {"Edit Name"}
                    </div>
                }
                placement="right"
                closable={true}
                width={400}
                onClose={this.onClose}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class CitiesDrawer extends Component {
    state = {
        visible: true,
        showEditDrawer: false,
        record: {}
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        })
    }


    deleteCity = async (cityId) => {
        let response = await Request.deleteCity({ cityId })
        if (response.success) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
        this.table.current.reload();
    }


    closeEditDrawer = () => {
        this.setState({ showEditDrawer: false, record: {} }, () => {
            this.table.current.reload();
        })
    }


    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { countryId } = this.props
            let response = await Request.loadCitiesByCountry(countryId)
            if (response.result) {
                response.data = response.result;
                delete response.result;
            }
            resolve(response)
        })
    }

    render() {
        let { visible } = this.state;
        const columns = [
            {
                title: 'City Name',
                dataIndex: 'cityName',
                width: 120,
                editable: true
            },
            {
                title: 'Created By',
                key: 'createdByUser.name',
                dataIndex: 'createdByUser.name',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.createdByUser ? record.createdByUser.name : "NA"}</div>
                            <small>{record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                key: 'updatedByUser.name',
                dataIndex: 'updatedByUser.name',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.updatedByUser ? record.updatedByUser.name : "NA"}</div>
                            <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                dataIndex: 'operation',
                render: (text, record) => (
                    <div>
                        <Tooltip title="Edit City Name">
                            <Button shape='circle' icon='edit' size='small' onClick={() => this.setState({ showEditDrawer: true, record: record })} />
                        </Tooltip>
                        <Tooltip title="Delete City">
                            <Popconfirm
                                title="Are you sure to delete city?"
                                onConfirm={() => this.deleteCity(record._id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button shape='circle' icon='delete' size='small' />
                            </Popconfirm>

                        </Tooltip>
                    </div>

                )
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        {"Cities"}
                    </div>
                }
                placement="right"
                closable={true}
                width={800}
                onClose={this.onClose}
                visible={visible}>
                <Card bordered={true}>
                    {
                        this.state.showEditDrawer ?
                            <EditNameDrawer type='city' record={this.state.record} onClose={this.closeEditDrawer} />
                            : null
                    }
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }

}

class StateDrawer extends Component {
    state = {
        visible: true,
        showEditDrawer: false,
        record: {}
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        })
    }

    deleteState = async (stateId) => {
        let response = await Request.deleteState({ stateId });
        if (response.success) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
        this.table.current.reload();
    }

    closeEditDrawer = () => {
        this.setState({ showEditDrawer: false, record: {} }, () => {
            this.table.current.reload()
        })
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { countryId } = this.props
            let response = await Request.loadStates(countryId);
            if (response.result) {
                response.data = response.result;
                delete response.result;
            }
            resolve(response)
        })
    }

    render() {
        let { visible } = this.state;
        const columns = [
            {
                title: 'State Name',
                dataIndex: 'stateName',
                width: 80,
                editable: true
            },
            {
                title: 'Created By',
                key: 'createdByUser.name',
                width: 80,
                dataIndex: 'createdByUser.name',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.createdByUser ? record.createdByUser.name : "NA"}</div>
                            <small>{record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                key: 'updatedByUser.name',
                width: 80,
                dataIndex: 'updatedByUser.name',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.updatedByUser ? record.updatedByUser.name : "NA"}</div>
                            <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                width: 80,
                dataIndex: 'operation',
                render: (text, record) => (
                    <div>
                        <Tooltip title="Edit State Name">
                            <Button shape='circle' icon='edit' size='small' onClick={() => this.setState({ showEditDrawer: true, record: record })} />
                        </Tooltip>
                        <Tooltip title="Delete State">
                            <Popconfirm
                                title="Are you sure to delete state?"
                                onConfirm={() => this.deleteState(record._id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button shape='circle' icon='delete' size='small' />
                            </Popconfirm>

                        </Tooltip>
                    </div>
                )
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        {"States"}
                    </div>
                }
                placement="right"
                closable={true}
                width={800}
                onClose={this.onClose}
                visible={visible}>
                <Card bordered={true}>
                    {
                        this.state.showEditDrawer ?
                            <EditNameDrawer type='state' record={this.state.record} onClose={this.closeEditDrawer} />
                            : null
                    }
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}



@Form.create()
class EditCountryProcess extends Component {
    state = {
        visible: true,
        leadStatuses: []
    }


    handleSubmit = (e) => {
        let { form, record } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values._id = record._id;
            values.countryId = record.countryId;
            if (values.systemKey === 'None') {
                values.systemKey = null;
            }
            let response = await Request.changeCountryProcess(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 200)
    }

    getAllLeadStatuses = async () => {
        let response = await Request.getLeadStatusDetails({
            results: 1000,
            count: 1000
        });
        if (response && response.data) {
            const allowedLeadStatuses = response.data.filter(ls => ls.desk && (ls.desk.includes('Application Desk') || ls.desk.includes('Visa Desk')));
            const statusNames = allowedLeadStatuses.map(ls => ls.statusName);
            this.setState({ leadStatuses: statusNames });
        }
    }

    componentDidMount() {
        this.getAllLeadStatuses();
        setTimeout(() => {
            this.props.form.setFieldsValue(this.props.record)
        }, 400)
    }

    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props
        let inputTypes = {
            fields: [
                {
                    label: 'Status Name',
                    key: 'name',
                    required: true,
                    type: 'select',
                    options: this.state.leadStatuses,
                    onChange: v => {
                        setFieldsValue({ name: v })
                    }
                },
                {
                    label: 'Desk',
                    key: 'desk',
                    type: 'select',
                    required: true,
                    options: ["Application Status", "Application Offer Status", "Student File Status", "Visa File Status", "Refund Status"],
                    onChange: v => {
                        setFieldsValue({ desk: v })
                    }
                },
                {
                    label: 'System Trigger',
                    key: 'systemKey',
                    type: 'select',
                    options: ["None", "Visa Approved", "Visa Refused", "Visa Withdrawal", "Visa File Dispatched", "Processed", "Conditional Offer Received", "Unconditional Offer Received"],
                    onChange: v => {
                        setFieldsValue({ systemKey: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        {"Edit Country Process"}
                    </div>
                }
                placement="right"
                closable={true}
                width={500}
                onClose={this.onClose}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class CountryProcessesDrawer extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef();
    }
    state = {
        visible: true,
        processData: [],
        showEditProcessDrawer: false,
        record: {}
    }


    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            let { countryId } = this.props
            params.countryId = countryId
            let response = await Request.getAllCountryProcesses(params)
            return resolve(response)
        })
    }

    componentDidMount() {
    }

    handleProcessDelete = async (recordId) => {
        let deleteData = {
            countryId: this.props.countryId,
            processId: recordId
        }
        let response = await Request.deleteCountryProcess(deleteData)
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload()
    }

    handleProcessEdit = async (record) => {
        record.countryId = this.props.countryId
        this.setState({ record, showEditProcessDrawer: true })
    }

    closeEditProcessDrawer = () => {
        this.setState({ record: {}, showEditProcessDrawer: false }, () => {
            this.table.current.reload()
        })
    }


    changeProcessStatus = async (value) => {
        let { record, checked } = value
        let data = {
            processId: record._id,
            countryId: this.props.countryRecord._id,
            checked: checked
        }
        let response = await Request.changeCountryProcessStatus(data)
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload()
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        const columns = [
            {
                title: 'Status Name',
                key: 'name',
                dataIndex: 'name'
            },
            {
                title: 'Desk',
                key: 'desk',
                dataIndex: 'desk'
            },
            {
                title: 'System Trigger',
                key: 'systemKey',
                dataIndex: 'systemKey',
                render: (text) => text || '-'
            },
            {
                title: 'Status',
                key: 'active',
                dataIndex: 'active',
                render: (text, record) => (
                    <Switch checked={record.active} onChange={(checked) => this.changeProcessStatus({ record, checked })} />
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <>
                        <Tooltip title="Edit Process">
                            <Button
                                shape="circle"
                                onClick={() => this.handleProcessEdit(record)}
                                icon="edit" />
                        </Tooltip>
                        <Tooltip title="Delete Process">
                            <Popconfirm title="Are you sure to delete Process?"
                                onConfirm={() => this.handleProcessDelete(record._id)}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    shape="circle"
                                    icon="delete" />
                            </Popconfirm>
                        </Tooltip>
                    </>
                )
            }
        ]

        return (
            <Drawer
                title={
                    <div>
                        {"Country Processes"}
                    </div>
                }
                placement="right"
                closable={true}
                width={700}
                onClose={this.onClose}
                visible={this.state.visible}>
                <Card bordered={true}>
                    {
                        this.state.showEditProcessDrawer ?
                            <EditCountryProcess record={this.state.record} onClose={this.closeEditProcessDrawer} />
                            : null
                    }
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        showSelector={true}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }
}


class CountryFactSheet extends React.Component {
    state = {
        visible: true,
        countryData: {}
    }


    loadApis = async () => {
        let { record } = this.props
        let response = await Request.getCountryWithUniversities({ _id: record._id })
        this.setState({ countryData: response });
    }

    componentDidMount() {
        this.loadApis()
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }

    downloadInvoice = () => {
        const printContents = document.getElementById('table_with_data').innerHTML;

        // Open a new window
        const printWindow = window.open('', '_blank', 'width=800,height=600');

        // Write the contents to the new window
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Fact Sheet Of ${this.props.record.countryName}</title>
              <style>
                /* Add any styles you want for printing */
                body {
                  font-family: Arial, sans-serif;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                table, th, td {
                  border: 1px solid black;
                }
                th, td {
                  padding: 8px;
                  text-align: left;
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();

        // Print the new window
        printWindow.print();

        // Optionally close the print window after printing
        printWindow.onafterprint = () => {
            printWindow.close();
        };
    };

    render() {
        let { visible, countryData } = this.state;
        let { record } = this.props;
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Fact Sheet of {record.countryName}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}>
                <Card>
                    <Tooltip title="Download Invoice">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => { this.downloadInvoice() }}
                        />
                    </Tooltip>
                    <Card id="table_with_data" loading={!this.state.countryData}>
                        {/* Country Name */}
                        <div style={{ textAlign: 'center' }}><h2 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>{countryData && countryData.countryDoc && countryData.countryDoc.countryName ? countryData.countryDoc.countryName : null}</h2></div>
                        {/* Country Details */}
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <tbody>
                                    {/* Currency Rate */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Currency Rate in {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.currencyRate ? countryData.countryDoc.currencyRate : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Main States */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Main States</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.mainStates ? countryData.countryDoc.mainStates : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Main Cities */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Main Cities</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.mainCities ? countryData.countryDoc.mainCities : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Consultancy Fee */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Consultancy ({companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null})</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Stage 1 (Application) :- {countryData && countryData.countryDoc && countryData.countryDoc.stageApplication ? countryData.countryDoc.stageApplication : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Stage 2 (Visa Filling) :- {countryData && countryData.countryDoc && countryData.countryDoc.stageVisaFilling ? countryData.countryDoc.stageVisaFilling : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Stage 3 (Visa Approval) :- {countryData && countryData.countryDoc && countryData.countryDoc.stageVisaApproval ? countryData.countryDoc.stageVisaApproval : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Visa Fee */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Visa Fee ({companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null})</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Main Applicant :- {countryData && countryData.countryDoc && countryData.countryDoc.visaFeeMainApplicant ? countryData.countryDoc.visaFeeMainApplicant : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Spouse :- {countryData && countryData.countryDoc && countryData.countryDoc.visaFeeSpouse ? countryData.countryDoc.visaFeeSpouse : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Each Child :- {countryData && countryData.countryDoc && countryData.countryDoc.visaFeeChild1 ? countryData.countryDoc.visaFeeChild1 : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* VFS/TTS Fee */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>VFF/TTS Fee ({companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null})</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Main Applicant :- {countryData && countryData.countryDoc && countryData.countryDoc.mainApplicantVfs ? countryData.countryDoc.mainApplicantVfs : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Spouse :- {countryData && countryData.countryDoc && countryData.countryDoc.spouseVfs ? countryData.countryDoc.spouseVfs : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Each Child :- {countryData && countryData.countryDoc && countryData.countryDoc.child1Vfs ? countryData.countryDoc.child1Vfs : null} {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Air Ticket Type */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Air Ticket Type</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.airTicketType ? countryData.countryDoc.airTicketType : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Air Ticket Price */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Air Ticket Price {companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : null}</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.airTicketPrice ? countryData.countryDoc.airTicketPrice : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Visa Filling By */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Visa Filling By</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.visaFillingBy ? countryData.countryDoc.visaFillingBy : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Interview */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Interview</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.interview ? countryData.countryDoc.interview : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Acceptable Funds */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Acceptable Funds</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.fundAcceptable ? countryData.countryDoc.fundAcceptable : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Acceptable Sponsors */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Acceptable Sponsors</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.fundSponsors ? countryData.countryDoc.fundSponsors : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Education Loan Acceptable */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Education Loan Acceptable</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.fundEducation ? countryData.countryDoc.fundEducation : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Basic Admission Documents */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Basic Admission Documents</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.enrollmentBasic ? countryData.countryDoc.enrollmentBasic : null}</span></strong></p>
                                        </td>
                                    </tr>
                                    {/* Procedure Steps */}
                                    <tr>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Procedure Steps</span></strong></p>
                                        </td>
                                        <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{countryData && countryData.countryDoc && countryData.countryDoc.enrollmentProcedure ? countryData.countryDoc.enrollmentProcedure : null}</span></strong></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* Universities */}
                        <div style={{ textAlign: 'center', marginTop: 30 }}><h3 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Universities in {countryData && countryData.countryDoc && countryData.countryDoc.countryName ? countryData.countryDoc.countryName : null}</h3></div>
                        <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>University Name</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Website</span></strong>
                                            </p>
                                        </th>
                                        <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>City</span></strong>
                                            </p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        countryData && countryData.universities && countryData.universities.length ?
                                            countryData.universities.map((university) => (

                                                <tr key={university._id}>
                                                    {/* University Name */}
                                                    <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                        <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{university && university.universityInstitutionName ? university.universityInstitutionName : null}</span></strong></p>
                                                    </td>
                                                    {/* University Website */}
                                                    <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                        <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{university && university.universityWebsite ? university.universityWebsite : null}</span></strong></p>
                                                    </td>
                                                    {/* University City */}
                                                    <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                                                        <p style={{ margin: '0cm', textAlign: 'center', marginBottom: '.0001pt', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{university && university.universityCityId && university.universityCityId.cityName ? university.universityCityId.cityName : null}</span></strong></p>
                                                    </td>
                                                </tr>

                                            ))
                                            : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </Card>
            </Drawer>
        )
    }
}


class AllCountry extends React.Component {
    state = {
        total: 0,
        time: {
            key: 'time',
            from: null,
            to: null
        },
        printLoading: {},
        exportLoading: false,
        showCountryProcessDrawer: false,
        countryRecord: '',
        showStatesDrawer: false,
        countryId: '',
        showCountryFactSheetDrawer: false,
        recordForFact: {}
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = params => {
        let dateFilter = null
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'countryName'
                params.sortOrder = 'ascend'
            }

            params.businessId = currentUser.businessId;

            this.setState({ exportParams: params })

            let data = await Request.getCountries({
                ...params,
                regExFilters: ['countryName', 'lastUpdatedByName'],
                dateFilter: this.state.time
            })
            this.setState({ total: data.total })
            resolve(data)
        })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                key: 'time',
                from: date[0],
                to: date[1]
            }
        })
        if (date[0] == undefined) {
            setTimeout(() => {
                this.reload()
            }, 500)
        }
    }
    onOk = value => {
        this.reload()
    }
    reload = () => {
        this.table.current.reload()
    }
    exportExcel = async () => {
        const { exportParams } = this.state

        this.setState({ exportLoading: true })
        let x = await Request.exportCountriesToExcel({
            ...exportParams, regExFilters: ['countryName'
            ]
        })
        this.setState({ exportLoading: false })

        if (!x.error) {
            window.open(x.url)
        }

    }

    printCountryDetails = async data => {
        // data.printLoading = true
        let printLoading = this.state.printLoading;
        printLoading[data.id] = true;
        this.setState({ printLoading: printLoading })
        let resp = await Request.printCountryDetails(data)
        printLoading[data.id] = false;
        this.setState({ printLoading: printLoading })
        // data.printLoading = false
        if (resp && resp.pdfName) {
            window.open(`${MEDIA_URL}storage/${resp.pdfName}`)
        } else {
            notification.error({
                message: 'Error',
                description: 'Try again'
            })
        }
    }


    viewCountryDetails = (data) => {
        this.setState({ showCountryFactSheetDrawer: true, recordForFact: data })
    }

    closeCountryFactSheetDrawer = () => {
        this.setState({ showCountryFactSheetDrawer: false, recordForFact: {} })
    }

    handleDelete = (val) => {
        Request.deleteCountry({ id: val })
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    showProcessesDrawer = (record) => {
        this.setState({ countryRecord: record, showCountryProcessDrawer: true })
    }

    closeCountryProcessDrawer = () => {
        this.setState({ countryRecord: '', showCountryProcessDrawer: false })
    }

    closeStateDrawer = () => {
        this.setState({ showStatesDrawer: false, countryId: null }, () => {
            this.table.current.reload();
        });
    }

    closeCitiesDrawer = () => {
        this.setState({ showCitiesDrawer: false, countryId: null }, () => {
            this.table.current.reload();
        });
    }

    openStateDrawer = (countryId) => {
        this.setState({ showStatesDrawer: true, countryId: countryId })
    }

    openCitiesDrawer = (countryId) => {
        this.setState({ showCitiesDrawer: true, countryId: countryId })
    }

    componentDidMount() {
    }

    render() {
        const { dispatch } = this.props
        const { printLoading } = this.state;
        const columns = [
            {
                title: 'Country',
                dataIndex: 'countryName',
                key: 'countryName',
                width: 100,
                fixed: 'left',
                searchTextName: 'countryName',
                filterRegex: true,
                sorter: true,
                render: (val, record) => {
                    return (
                        <Tooltip title="Click To Edit Details">
                            <a
                                href={`/location/edit-country?id=${record._id}`}
                            >
                                {val}
                            </a>
                        </Tooltip>
                    )
                }
            },
            {
                title: 'States', dataIndex: 'stateCount', render: (text, record) => (
                    <a onClick={() => this.openStateDrawer(record._id)}>{text}</a>
                )
            },
            {
                title: 'Cities', dataIndex: 'cityCount', render: (text, record) => (
                    <a onClick={() => this.openCitiesDrawer(record._id)}>{text}</a>
                )
            },
            { title: 'Phone Code', dataIndex: 'countryPhoneCode' },
            { title: 'Code', dataIndex: 'countryCode' },
            { title: 'Currency', dataIndex: 'currencyName', key: 'currencyName' },
            { title: 'Rate', dataIndex: 'currencyRate' },
            {
                title: 'Consultancy Total',
                render: (val, record) => {
                    val.stageApplication = val.stageApplication ? val.stageApplication : 0
                    val.stageVisaFilling = val.stageVisaFilling ? val.stageVisaFilling : 0
                    val.stageVisaApproval = val.stageVisaApproval
                        ? val.stageVisaApproval
                        : 0
                    return (
                        <div>
                            {val.stageApplication +
                                val.stageVisaFilling +
                                val.stageVisaApproval}
                        </div>
                    )
                }
            },
            { title: 'Visa Fee (Main)', dataIndex: 'visaFeeMainApplicant' },
            { title: 'VFS Fee (Main)', dataIndex: 'mainApplicantVfs' },
            { title: 'Living Cost (Main)', dataIndex: 'livingCostMainApplicant' },
            { title: 'Visa Filing', dataIndex: 'visaFillingBy' },
            { title: 'Interview', dataIndex: 'interview' },
            {
                title: 'Visa Processing Time',
                width: 200,
                dataIndex: 'visaProcessingTime'
            },
            {
                title: 'Visa Checklist',
                dataIndex: 'fundVisaCheckList',
                render: (val, record) => {
                    let ff = record.fundVisaChecklist
                        ? record.fundVisaChecklist.length
                            ? record.fundVisaChecklist[0]
                            : ''
                        : ''
                    return ff ? (
                        <a href={ff.url} target={'_blank'}>
                            Download
                        </a>
                    ) : null
                }
            },
            {
                title: 'Updated By',
                width: 150,
                key: 'updatedByUser',
                searchTextName: 'updatedByUser.name',
                filterRegex: true,
                dataIndex: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                dataIndex: 'createdByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>

                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                fixed: 'right',
                width: 210,
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'Country.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    href={`/location/edit-country?id=${record._id}`}
                                    icon="edit" />
                            </Tooltip>
                        </RightsWrapper>

                        <Tooltip title="Fact Sheet ">
                            <Button loading={printLoading[record.id]}
                                className={styles.btn}
                                shape="circle" onClick={() => {
                                    this.printCountryDetails(record)
                                }} icon="download" />
                        </Tooltip>
                        <Tooltip title="View Fact Sheet ">
                            <Button loading={printLoading[record.id]}
                                className={styles.btn}
                                shape="circle" onClick={() => {
                                    this.viewCountryDetails(record)
                                    // this.printCountryDetails(record)
                                }} icon="eye" />
                        </Tooltip>
                        <RightsWrapper myRight={'Country.edit'}>
                            <Tooltip title="Delete Country">
                                <Popconfirm
                                    title="Are you sure to delete Country?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete" />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        {/* <RightsWrapper myRight={'processDocument.view'}>
                            <Tooltip title="Process Documents">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    href={`/location/process-country?id=${record._id}`}
                                    icon="file" />
                            </Tooltip>
                        </RightsWrapper> */}
                        <RightsWrapper myRight={'processDocument.view'}>
                            <Tooltip title="Manage Processes">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    onClick={() => this.showProcessesDrawer(record)}
                                    icon="setting" />
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Total Countries : ${this.state.total} `}>
                {
                    this.state.showCountryProcessDrawer ?
                        <CountryProcessesDrawer countryId={this.state.countryRecord._id} countryRecord={this.state.countryRecord ? this.state.countryRecord : []} onClose={this.closeCountryProcessDrawer} />
                        : null
                }
                {
                    this.state.showStatesDrawer ?
                        <StateDrawer countryId={this.state.countryId} onClose={this.closeStateDrawer} />
                        : null
                }
                {
                    this.state.showCitiesDrawer ?
                        <CitiesDrawer countryId={this.state.countryId} onClose={this.closeCitiesDrawer} />
                        : null
                }
                {
                    this.state.showCountryFactSheetDrawer ?
                        <CountryFactSheet record={this.state.recordForFact} onClose={this.closeCountryFactSheetDrawer} />
                        : null
                }
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                            <h4>FILTER BY LAST UPDATE</h4>
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={['Start Time', 'End Time']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={10}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                {
                                    userRights.checkRights("CountryExcelExport.view") ?
                                        <Button type={'default'}
                                            loading={this.state.exportLoading}
                                            onClick={() => {
                                                this.exportExcel()
                                            }}>
                                            Export Excel
                                        </Button>
                                        : null
                                }
                            </div>
                        </Col>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Link to='/location/add-country'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        extraProps={{ scroll: { x: 2100 } }}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllCountry)
